<mat-accordion>
    <mat-expansion-panel class="mt-5" hideToggle="true" #availabilityAccordion>
      <mat-expansion-panel-header
        (click)="exp_Accordion(availabilityAccordion.expanded)"
      >
        <mat-panel-title>
          <span class="svg-icon svg-icon-3x">
            <span [inlineSVG]="AvailabilityIconPath"></span>
          </span>
          <h3 class="text-dark font-weight-bold ml-3">
            <span class="mr-3">Unavailability</span>
              <br />
            <span class="text-muted font-weight-light font-size-sm"
              >View and update provider unavailability timing</span
            >
          </h3>
        </mat-panel-title>
        <mat-panel-description class="expansion_right">
          <button
            *ngIf="!availabilityAccordion.expanded"
            mat-icon-button
            class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
            color="primary"
          >
            <span class="material-icons"> keyboard_arrow_down </span>
          </button>

          <button
            *ngIf="availabilityAccordion.expanded"
            mat-icon-button
            class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
            color="primary"
          >
            <span class="material-icons"> keyboard_arrow_up </span>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="mt-6"></div>

      <ng-container>
        <mat-toolbar
          class="margin-top-0px"
          *ngIf="availabilityAccordion.expanded && !isCreateAvailability"
          color="primary"
        >
          <mat-toolbar-row class="subheader">
            <form class="form col-xs-12 col-md-12">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                  <mat-form-field class="example-full-width">
                    <input
                      [matDatepicker]="fromdatepicker"
                      matInput
                      (click)="fromdatepicker.open()"
                      placeholder="From Date"
                      #fromdate
                      required
                      [(ngModel)]="from_date"
                      name="from_date"
                      autocomplete="off"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="fromdatepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #fromdatepicker
                      disabled="false"
                      color="primary"
                      touchUi
                    ></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                  <mat-form-field class="example-full-width">
                    <input
                      [matDatepicker]="todatepicker"
                      matInput
                      (click)="todatepicker.open()"
                      placeholder="To Date"
                      #todate
                      ngModel
                      [min]="from_date"
                      required
                      name="to_date"
                      autocomplete="off"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="todatepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #todatepicker
                      disabled="false"
                      color="primary"
                      touchUi
                    ></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                  <button
                    (click)="applyFilter(fromdate.value, todate.value)"
                    mat-icon-button
                    class="btn btn-primary"
                  >
                    <mat-icon>search</mat-icon>
                  </button>

                  <!-- <span class="example-spacer"></span> -->
                  <button
                  *ngIf="action.Create"
                    mat-raised-button
                    (click)="showcreateAvailability('add', -1)"
                    class="btn btn-secondary example-icon floatright pl-3"
                    aria-label="Add a New Schools"
                  >
                    <mat-icon class="a2z-maticon">add</mat-icon>
                    Add
                  </button>
                </div>
              </div>
            </form>
          </mat-toolbar-row>
        </mat-toolbar>

        <div
          *ngIf="availabilityAccordion.expanded && !isCreateAvailability"
          class="table-responsive"
        >
          <table
            mat-table
            [dataSource]="availabilitydataSource"
            class="mat-elevation-z1"
          >
            <!--- Note that these columns can be defined in any order.
                       The actual rendered columns are set as a property on the row definition" -->

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="font-size-lg mb-0"
              >
                {{ i + 1 + Page_Size * (Page_Index - 1) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td
                mat-cell
                *matCellDef="let element"
                class="font-size-lg mb-0 text-capitalize"
              >
                {{ element.from_date | TimeDateFormat }}
              </td>
            </ng-container>


            <ng-container matColumnDef="timing">
              <th mat-header-cell *matHeaderCellDef>Unavailability Timing</th>
              <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
                {{ todayDate + ' ' +element.timing.from_time | date: 'h:mm a' }}
                 -
                {{ todayDate + ' ' +element.timing.to_time | date: 'h:mm a' }}
              </td>
            </ng-container>


            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
                {{ element.available_type }}
              </td>
            </ng-container>



            <ng-container matColumnDef="actions">
              <th mat-header-cell [hidden]="!action.Edit" *matHeaderCellDef class="textaligncenter">
                Actions
              </th>
              <td mat-cell [hidden]="!action.Edit" *matCellDef="let element">
                <div class="text-center" *ngIf="action.Edit">
                  <button
                    mat-icon-button
                    class="btn btn-sm btn-default btn-text-secondary btn-icon mr-2"
                    color="secondary"
                    (click)="deleteAvailability(element.id)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-secondary">
                      <span [inlineSVG]="deleteicon"></span>
                    </span>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="availability_displayedColumns"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: availability_displayedColumns"
            ></tr>
          </table>
          <mat-paginator
            [length]="totalLength"
            [pageSize]="Page_Size"
            [showFirstLastButtons]="true"
            [pageSizeOptions]="PageSize_Options"
            (page)="getAvailabilityList($event)"
          >
          </mat-paginator>
        </div>
      </ng-container>

      <school-unavailability-form
        *ngIf="isCreateAvailability"
        [user_id]="user_id"
        [formtype]="FormStatus"
        (cancelEvent)="showAvailabilitylist()"
      >
      </school-unavailability-form>
    </mat-expansion-panel>
  </mat-accordion>
